import { Squares2X2Icon } from "@heroicons/react/24/outline";
import ListingImageGallery from "components/ListingImageGallery/ListingImageGallery";
import { ListingGalleryImage } from "components/ListingImageGallery/utils/types";
import {
    useLocation,
    useNavigate,
    useSearchParams,
  } from "react-router-dom";


type Props = {
  photos: ListingGalleryImage[];
};

export const ListingStayDetailHeader = ({ photos }: Props) => {
  const navigate = useNavigate();

  const thisPathname = useLocation().pathname.replace(/\/$/, "");
  const [searchParams] = useSearchParams();
  const modal = searchParams?.get("modal");
  const params = new URLSearchParams(document.location.search);

  const handleOpenModalImageGallery = () => {
    navigate(`${thisPathname}/?${params.toString()}&modal=PHOTO_TOUR_SCROLLABLE`);
  };

  const handleCloseModalImageGallery = () => {
    params.delete("modal");
    navigate(`${thisPathname}?${params.toString()}`);
  };

  return (
    <div className="">
      <div className="ListingDetailPage mt-8">
        <ListingImageGallery
          isShowModal={modal === "PHOTO_TOUR_SCROLLABLE"}
          onClose={handleCloseModalImageGallery}
          images={photos}
        />

        <header className="rounded-md sm:rounded-xl">
          <div className="relative grid grid-cols-3 sm:grid-cols-4 gap-1 sm:gap-2">
            <div
              className="col-span-2 row-span-3 sm:row-span-2 relative rounded-md sm:rounded-xl overflow-hidden cursor-pointer "
              onClick={handleOpenModalImageGallery}
            >
              <img
                className="absolute inset-0 object-cover rounded-md sm:rounded-xl w-full h-full"
                src={photos[0].url}
                alt="Foto do hotel"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
              />
              <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
            </div>
                {photos.slice(1, 5).map((item, index) => (
                <div
                    key={item.id}
                    className={`relative rounded-md sm:rounded-xl overflow-hidden ${
                    index >= 3 ? "hidden sm:block" : ""
                    }`}
              >
                <div className="aspect-w-4 aspect-h-3 sm:aspect-w-6 sm:aspect-h-5">
                  <img
                    className="absolute inset-0 object-cover object-center rounded-md scale-150 sm:rounded-xl w-full h-full"
                    src={item.url || ""}
                    alt=""
                    sizes="400px"
                  />
                </div>

                {/* OVERLAY */}
                <div
                  className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                  onClick={handleOpenModalImageGallery}
                />
              </div>
            ))}

            <button
              className="absolute hidden md:flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-xl bg-neutral-100 text-neutral-500 hover:bg-neutral-200 z-10"
              onClick={handleOpenModalImageGallery}
            >
              <Squares2X2Icon className="w-5 h-5" />
              <span className="ml-2 text-neutral-800 text-sm font-medium">
                Mostrar todas as fotos
              </span>
            </button>
          </div>
        </header>
      </div>
    </div>
  );
};
